import { BonusHistoryEffects } from './bonus-history.effects';
import { BonusStatusEffects } from './bonus-status.effects';
import { ForemanPromocodesEffects } from './foreman-promocodes.effects';
import { OrderDocumentEffects } from './order-document.effects';
import { PersonalManagerCommonEffects } from './personal-manager-common.effects';
import { PersonalManagerConfirmationEffects } from './personal-manager-confirmation.effects';
import { PersonalManagersListEffects } from './personal-managers-list.effects';

export const effects: any[] = [
  OrderDocumentEffects,
  PersonalManagerConfirmationEffects,
  PersonalManagersListEffects,
  PersonalManagerCommonEffects,
  BonusHistoryEffects,
  BonusStatusEffects,
  ForemanPromocodesEffects,
];
